<div [formGroup]="formGroup" class="form-group" [class.has-error]="!isValid(formGroup, ctrl)" [libCtrConfigUI]="ctrl" [altura]="ctrl?.Altura" [isMobile]="isMobile">
  <button [libCtrConfigUI]="ctrl" [altura]="ctrl?.Altura" class="form-control" type="button" [tabIndex]="getTabIndex(ctrl)" >{{ ctrl?.ValorTexto }}</button>
</div>
